<script setup lang="ts">
import { computed } from "vue";

// shared
import { usePopupManager } from "@/shared/composables/usePopupManager";
import BasePopup from "@/shared/components/popup/BasePopup.vue";

// features
import DetailRegistrationUserPopup from "@/features/pending-registration/ui/detail-popup/index.vue";
import type {
    PendingRegistrationUserProps,
    DetailPendingRegistrationPopupProps,
} from "@/features/pending-registration/models/interface";

const props = defineProps<PendingRegistrationUserProps>();

const { openPopup } = usePopupManager();

const userName = computed(() => {
    return props.name.length > 5 ? props.name.slice(0, 5) + "..." : props.name;
});

/**
 * @description
 * 해당 유저의 상세 정보 팝업을 띄어줍니다.
 */
const openUserDetailPopup = () => {
    openPopup<DetailPendingRegistrationPopupProps>({
        component: BasePopup,
        props: {
            closeKey: "",
            innerComponent: DetailRegistrationUserPopup,
            rest: {
                title: "승인 상세정보",
                registrationId: props.registrationId,
                userType: props.unConvertedType,
                userId: props.userId,
            },
        },
    });
};
</script>

<template>
    <div class="flex justify-between items-center w-full">
        <div class="w-[4.5rem] h-[2.4rem] flex justify-center items-center">
            <p class="font-bold font-pretendard text-body-medium text-t-basic">{{ type }}</p>
        </div>
        <div class="w-[10rem] h-[2.4rem] flex justify-center items-center">
            <p class="font-bold font-pretendard text-body-medium text-t-basic">{{ userName }}</p>
        </div>
        <div class="w-[5.6rem] h-[2.4rem] flex justify-center items-center">
            <p class="font-normal font-pretendard text-body-medium text-t-basic">
                {{ registrationDate }}
            </p>
        </div>
        <div
            class="w-[3.2rem] h-[2.4rem] flex justify-center items-center"
            @click="openUserDetailPopup"
        >
            <p
                class="font-normal cursor-pointer text-body-small font-pretendard text-t-basic active:scale-98"
            >
                보기
            </p>
        </div>
    </div>
</template>
